import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/ArticlePage";
import GenericPage from "@/pages/GenericPage";
import PillarArticlePage from "@/pages/PillarArticlePage";
import ProductsPage from "@/pages/ProductsPage";
import Layout from "@/components/feature/Layout";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/en",
        element: <Home />,
      },
      {
        path: "/pt",
        element: <Home />,
      },
      {
        path: "/de",
        element: <Home />,
      },
      {
        path: "/en/products",
        element: <ProductsPage />,
      },
      {
        path: "/pt/products",
        element: <ProductsPage />,
      },
      {
        path: "/de/products",
        element: <ProductsPage />,
      },
      {
        path: "/en/cssbuy-spreadsheet",
        element: <ArticlePage />,
      },
      {
        path: "/pt/cssbuy-spreadsheet",
        element: <ArticlePage />,
      },
      {
        path: "/de/cssbuy-spreadsheet",
        element: <ArticlePage />,
      },
      {
        path: "/en/articles/:slug",
        element: <PillarArticlePage />,
      },
      {
        path: "/pt/articles/:slug",
        element: <PillarArticlePage />,
      },
      {
        path: "/de/articles/:slug",
        element: <PillarArticlePage />,
      },
      {
        path: "/en/:page",
        element: <GenericPage />,
      },
      {
        path: "/pt/:page",
        element: <GenericPage />,
      },
      {
        path: "/de/:page",
        element: <GenericPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;